import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';

import { ReportsService, TransformedSingleData } from '../../services/reports.service';
import { CommonService } from '../../services/common.service';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'grid-see-licence-check-link-button',
  template: `
    <span *ngIf="shouldBeButton">
      <button
        mat-button
        fxFlex
        class="grid-link-button grid-text"
        [style.color]="transformedValue?.color"
        (click)="triggerLinkButtonAction()"
      >
        {{ value }}
      </button>
    </span>
    <span *ngIf="!shouldBeButton">{{ value }}</span>
  `,
  styles: [],
})
export class GridSeeLicenceCheckLinkButton implements ICellRendererAngularComp {
  public value: string;
  public transformedValue: TransformedSingleData;
  public shouldBeButton = false;

  constructor(private router: Router, private cService: CommonService, public rptService: ReportsService) {}

  agInit(params: ICellRendererParams) {
    this.shouldBeButton = !['na', 'Non-UK Licence'].includes(params.data.dvlaLicenceStatus);
    this.transformedValue = this.rptService.transformSingleDataForDetailsPane('dvlaLicenceStatus', params.value);

    this.value = this.transformedValue
      ? this.cService.toVrmCaps(this.transformedValue.uiValue)
      : this.cService.toVrmCaps(params.value);
  }

  triggerLinkButtonAction() {
    if (this.cService.licenceCheckingIsHidden()) {
      this.cService.showToastWithoutDuration(
        this.cService.readyTranslations.messagesAndWarnings.insufficientPermissionToViewRequestedPage,
        'close'
      );
    } else {
      setTimeout(() => {
        this.rptService.gridSearch.text = this.rptService.selectedRows[0]['pin'];
        this.rptService.gridSearch.activated = true;

        if (this.value === 'Found') {
          this.router.navigate(['commonreports/licence-results']);
        } else {
          this.router.navigate(['commonreports/licence-administration']);
        }
      }, 250);
    }
  }

  refresh() {
    return false;
  }
}
